function formatCurrency(amount, currency, language = navigator && navigator.language.split("-").shift() || "en") {
  return new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency || "EUR",
    currencyDisplay: "narrowSymbol"
  }).format(amount);
}
export {
  formatCurrency
};
